import moment from 'moment-timezone'
import { extendMoment } from 'moment-range'

export const toMoment = datetime => moment(datetime)
export const startOfDay = datetime => moment(datetime).startOf('day')
export const getDate = datetime => moment(datetime).format('D MMM Y')
export const getDateKey = datetime => moment(datetime).format('YYYY-MM-DD')
export const getWeekDay = datetime => moment(datetime).format('dddd')
export const getTime = datetime => moment(datetime).format('h:mma')
export const getTimeHour = datetime => moment(datetime).format('H')
export const getTimeMinute = datetime => moment(datetime).format('m')
export const formatDateTimeNice = datetime => moment(datetime).format('MMMM Do YYYY, h:mma')
export const formatShortDateTimeNice = datetime => moment(datetime).format('MMM Do, h:mma')
export const toISOString = datetime => moment(datetime).toISOString()
export const isAfter = (datetime1, datetime2) => moment(datetime1).isAfter(moment(datetime2))
export const now = () => moment()
export const nowTimestamp = () => now().unix()
export const getHoursBefore = hours => now().subtract(hours, 'hours')
export const getSummaryDate = datetime => moment(datetime).format('dddd, MMMM D')
export const getSummaryTime = datetime => moment(datetime).format('LT')
export const isBetween = (date, startDate, endDate) => date.isBetween(startDate, endDate)
export const range = (startDate, endDate) => Array.from(extendMoment(moment).range(startDate, endDate).by('days'))

export const getPrevHour = (hour) => {
  const timeNow = now()
  if (timeNow.hour() < hour) {
    return timeNow.subtract(1, 'days').set({ hour, minute: 0, second: 0, millisecond: 0 })
  }
  return timeNow.set({ hour, minute: 0, second: 0, millisecond: 0 })
}

export const sort = (datetime1, datetime2) => {
  if (isAfter(datetime1, datetime2)) {
    return 1
  }
  if (isAfter(datetime2, datetime1)) {
    return -1
  }
  return 0
}

export const isSameDay = (a, b) => {
  if (!a || !b) {
    return false
  }

  if (!moment.isMoment(a) || !moment.isMoment(b)) {
    throw new Error('Invalid input parameters, expected moment dates.')
  }

  return a.isSame(b, 'day')
}

export const sortTimeRecord = (a, b) => {
  if (a.hour === b.hour && a.minute === b.minute) {
    return 0
  }
  if (a.hour < b.hour || (a.hour === b.hour && a.minute < b.minute)) {
    return -1
  }
  return 1
}



/** WEBPACK FOOTER **
 ** ./src/utils/datetime/datetime.js
 **/